import { AppContext } from './AppContext';
import client from "./apolloClient";
import { CustomerRating, FeedBackRating } from '../models/FeedbackRating';
import { UPDATE_CUSTOMER_RATING } from './mutation';
import { GET_RATING_BY_BOOKINGID } from './queries';

// const loggedAuthToken = Cookies.get('loggedAuthToken');




export const getRatingByBookingId = async (bookingId: string): Promise<FeedBackRating | null> => {

    try {
        const { data } = await client.query({
            query: GET_RATING_BY_BOOKINGID,
            variables: { bookingId },
            context: {
                headers: {
                    Authorization: AppContext.loggedAuthToken ? `Bearer ${AppContext.loggedAuthToken}` : '',
                },
            }
        });

        return data?.getFeedBackRatingByBookingId
    } catch (error) {
        console.log('Error fetching getRatingByBookingId:', error);
        return null;
    }
};




export const UpdateCustomerFeedBackRating = async (bookingId: string, ratingsByCustomer: CustomerRating, feedBackByCustomer: string): Promise<FeedBackRating | null> => {
    console.log("in service " + JSON.stringify(ratingsByCustomer))
    try {
        const { data } = await client.mutate({
            mutation: UPDATE_CUSTOMER_RATING,
            variables: { bookingId, ratingsByCustomer, feedBackByCustomer },
            context: {
                headers: {
                    Authorization: AppContext.loggedAuthToken ? `Bearer ${AppContext.loggedAuthToken}` : '',
                },
            }
        });
        return data?.updateCustomerFeedbackRating;
    } catch (error) {
        console.log('Error fetching UpdateCustomerFeedBackRating: ', error);
        return null;
    }
}

